// TODO: Rename this file when the other application type is no longer in the system

import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import moment from "moment";


const ApplicationFieldAssignment = ({ props }) => {
  const [alert, setAlert] = useState(false);
  useEffect(() => {
    if (props.app?.statusObj?.daysBeforeAlert && props.app?.statusDate) {
      let date = new Date(props.app?.statusDate);
      let currentDate = new Date();
      date.setDate(date.getDate() + props.app?.statusObj?.daysBeforeAlert);

      date <= currentDate ? setAlert(true) : setAlert(false);
    }
  }, [props.app?.statusObj?.daysBeforeAlert, props.app?.statusDate]);
  const [manualAddress, setManualAddress] = useState(false);

  useEffect(() => {
    if (props.app.address === "") {
      setManualAddress(true);
    }
  }, [props]);
  return (
    <tr
      onClick={() => {

        if (props.app.customerId) {
          props.modalController.openAppModal({
            customerId: props.app.customerId,
            appId: props.app.id,
            programId: props.app.programId,
            property: props.app.propertyId,
            app: props.app,
          });
        } else {
          props.modalController.openAppModal({
            customerId: 0,
            appId: props.app.id,
            programId: props.app.programId,
            property: props.app.propertyId,
            app: props.app,
          });
        }
      }}
      className={`rounded-lg dark:text-white text-black text-start hover:bg-blue-50 cursor-pointer `}
    >
      {props.view === "fieldAssignments" && (
        <>
          <td className="p-1 text-sm max-w-[100px] break-words cursor-pointer text-center">
            <a className="underline text-blue-reef">{props.app.id}</a>
          </td>
          <td className="p-1 text-sm max-w-[100px] break-words">{props.app.address}</td>

          <td className="p-1 text-sm max-w-[100px] break-words">{props.app.name}</td>
          <td className="p-1 text-sm max-w-[100px] break-words">
            {props.app.programName}
          </td>

          <td className="p-1 text-sm max-w-[100px] break-words">{props.app.status}</td>
          <td className="p-1 text-sm max-w-[100px] break-words">
            {props.app.currentStatus}
          </td>
        </>
      )}

      {props.view === "property" && (
        <>
          <td className="text-sm whitespace-nowrap cursor-pointer flex justify-center items-center gap-2">
            <a className="underline text-blue-reef mt-4">{props.app.id}</a>{" "}
          </td>
          <td className="p-3">
            {props.app.date ? (
              <Moment format="MM/DD/YYYY">{props.app.date}</Moment>
            ) : (
              ""
            )}
          </td>
          <td className="p-1 text-sm whitespace-nowrap">{props.app.address}</td>
          <td className="p-1 text-sm whitespace-nowrap">{props.app.name}</td>
          <td className="p-1 text-sm whitespace-nowrap">
            {props.app.programName}
          </td>
          <td className="p-1 text-sm whitespace-nowrap">
            {props.app.waterSavings || 0}
          </td>
          <td className="p-1 text-sm whitespace-nowrap">
            {props.app.cost || 0}
          </td>
          <td className="p-1 text-sm whitespace-nowrap">
            {props.app.currentStatus}
          </td>
        </>
      )}
    </tr>
  );
};

export default ApplicationFieldAssignment;
